(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/upcoming-events/assets/javascripts/upcoming-events.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/upcoming-events/assets/javascripts/upcoming-events.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useReducer = _React.useReducer,
  useRef = _React.useRef,
  useState = _React.useState;
const Button = svs.ui.ReactButton;
const _svs$poker_react$comp = svs.poker_react.components.common,
  _svs$poker_react$comp2 = _svs$poker_react$comp.constants,
  TournamentFilters = _svs$poker_react$comp2.TournamentFilters,
  GameTypes = _svs$poker_react$comp2.GameTypes,
  BuyinFiltersSEK = _svs$poker_react$comp2.BuyinFiltersSEK,
  SatelliteFilters = _svs$poker_react$comp2.SatelliteFilters,
  TournamentFetchMoreCount = _svs$poker_react$comp2.TournamentFetchMoreCount,
  launchWebClient = _svs$poker_react$comp.helpers.launchWebClient;
const _svs$poker_react$comp3 = svs.poker_react.components.upcomingEvents,
  FilterModal = _svs$poker_react$comp3.FilterModal,
  TournamentListItem = _svs$poker_react$comp3.TournamentListItem,
  HighlightedCard = _svs$poker_react$comp3.HighlightedCard,
  BuyinFilter = _svs$poker_react$comp3.BuyinFilter,
  GameTypeFilter = _svs$poker_react$comp3.GameTypeFilter,
  TournamentTypeFilter = _svs$poker_react$comp3.TournamentTypeFilter,
  Skeleton = _svs$poker_react$comp3.Skeleton,
  useGetTournamentEvents = _svs$poker_react$comp3.useGetTournamentEvents,
  SatelliteFilter = _svs$poker_react$comp3.SatelliteFilter;
const pokerSMVisible = svs.poker_react.data.upcomingEventsData.pokerSMVisible;
const _svs$poker_react$comp4 = svs.poker_react.components.upcomingEvents.filterReducer,
  reducer = _svs$poker_react$comp4.reducer,
  actionTypes = _svs$poker_react$comp4.actionTypes;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const ANIMATION_DURATION = 1;
const ANIMATION_EASING = 'sine.out';
const LIST_ITEM_HEIGHT = 90;
const UpcomingEvents = () => {
  const _useReducer = useReducer(reducer, {
      tournamentType: pokerSMVisible ? TournamentFilters[2].id : TournamentFilters[0].id,
      gameType: GameTypes[0].id,
      buyin: BuyinFiltersSEK[0],
      satellite: SatelliteFilters[0].value
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    activeFilters = _useReducer2[0],
    dispatch = _useReducer2[1];
  const isPokerSM = activeFilters.tournamentType === 'poker-sm';
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    offset = _useState2[0],
    setOffset = _useState2[1];
  const tournamentContainer = useRef();
  const upcomingEventsContainer = useRef();
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    liveMessage = _useState4[0],
    setLiveMessage = _useState4[1];
  const isWideDevice = useMediaQuery(breakpoints.up(BREAKPOINT_MD));
  const _useGetTournamentEven = useGetTournamentEvents(activeFilters, offset),
    tournaments = _useGetTournamentEven.tournaments,
    moreItems = _useGetTournamentEven.moreItems,
    shouldShowSkeleton = _useGetTournamentEven.shouldShowSkeleton,
    error = _useGetTournamentEven.error,
    isFetchingMore = _useGetTournamentEven.isFetchingMore;
  useEffect(() => {
    const container = tournamentContainer.current;
    if (container && offset > 0) {
      gsap.to(container, {
        maxHeight: container.scrollHeight + LIST_ITEM_HEIGHT * TournamentFetchMoreCount,
        duration: ANIMATION_DURATION,
        ease: ANIMATION_EASING
      });
    } else if (offset === 0) {
      container.removeAttribute('style');
    }
  }, [offset, isWideDevice]);
  useEffect(() => {
    if (liveMessage) {
      const timeout = setTimeout(() => setLiveMessage(''), 3000);
      return () => clearTimeout(timeout);
    }
  }, [liveMessage]);
  const setFilter = (actionType, payload) => {
    setOffset(0);
    dispatch({
      type: actionType,
      payload
    });
  };
  const goToTournament = (tournamentId, tournamentName) => {
    launchWebClient({
      tournamentId,
      tournamentName
    });
  };
  const renderFilters = () => {
    if (isPokerSM) {
      return React.createElement("div", {
        className: "satellite-filter-container"
      }, React.createElement(SatelliteFilter, {
        activeSatelliteFilter: activeFilters.satellite,
        setActiveSatelliteFilter: filter => setFilter(actionTypes.SET_SATELLITE_FILTER, filter)
      }));
    }
    return React.createElement("div", {
      className: "dropdown-container"
    }, React.createElement(GameTypeFilter, {
      activeGameTypeFilter: activeFilters.gameType,
      setActiveGameTypeFilter: filter => setFilter(actionTypes.SET_GAME_TYPE_FILTER, filter)
    }), React.createElement(BuyinFilter, {
      activeBuyinFilter: activeFilters.buyin,
      isNetwork: activeFilters.tournamentType === 'network',
      setActiveBuyinFilter: filter => setFilter(actionTypes.SET_BUY_IN_FILTER, filter)
    }));
  };
  const renderPokerEventsList = pokerEvents => {
    if (shouldShowSkeleton || !pokerEvents) {
      return React.createElement(Skeleton, null);
    }
    if (error) {
      return React.createElement("div", {
        className: "f-content error-message"
      }, React.createElement("h3", null, "N\xE5got gick fel"));
    }
    if (pokerEvents.length === 0) {
      return React.createElement("div", {
        className: "f-content error-message"
      }, React.createElement("h3", null, "Inga events hittades!"));
    }
    return pokerEvents.map((_ref, i) => {
      let tournamentId = _ref.tournamentId,
        registrationEndTime = _ref.registrationEndTime,
        name = _ref.name,
        buyIn = _ref.buyIn,
        registrationCount = _ref.registrationCount,
        startTime = _ref.startTime,
        isLateReg = _ref.isLateReg,
        currency = _ref.currency;
      if (pokerEvents.length === 1) {
        return React.createElement(TournamentListItem, {
          buyIn: buyIn,
          currency: currency,
          isLateReg: isLateReg,
          key: tournamentId,
          name: name,
          onClick: goToTournament,
          registrationCount: registrationCount,
          registrationEndTime: registrationEndTime,
          startTime: startTime,
          tournamentId: tournamentId
        });
      }
      if (i === 0) {
        return React.createElement(HighlightedCard, {
          buyIn: buyIn,
          currency: currency,
          isLateReg: isLateReg,
          key: tournamentId,
          name: name,
          onRegistrationClick: goToTournament,
          registrationCount: registrationCount,
          registrationEndTime: registrationEndTime,
          startTime: startTime,
          tournamentId: tournamentId
        });
      }
      return React.createElement(TournamentListItem, {
        buyIn: buyIn,
        currency: currency,
        isLateReg: isLateReg,
        key: tournamentId,
        name: name,
        onClick: goToTournament,
        registrationCount: registrationCount,
        registrationEndTime: registrationEndTime,
        startTime: startTime,
        tournamentId: tournamentId
      });
    });
  };
  return React.createElement("section", {
    className: "upcoming-events-container f-content",
    ref: upcomingEventsContainer
  }, React.createElement("span", {
    "aria-live": "polite",
    className: "sr-only"
  }, liveMessage), React.createElement("fieldset", null, React.createElement("legend", {
    className: "h2 center-text"
  }, "Turneringar"), isWideDevice && React.createElement(React.Fragment, null, React.createElement(TournamentTypeFilter, {
    activeTournamentFilter: activeFilters.tournamentType,
    setTournamentFilter: filter => {
      setFilter(actionTypes.SET_TOURNAMENT_FILTER, filter.id);
      const message = filter.id === 'poy' ? "Visar player of the year turneringar" : "Visar ".concat(filter.title);
      setLiveMessage(message);
    }
  }), renderFilters())), !isWideDevice && React.createElement(FilterModal, {
    activeFilters: activeFilters,
    dispatch: dispatch,
    isPokerSM: isPokerSM
  }), React.createElement("hr", {
    className: "divider"
  }), React.createElement("ul", {
    className: "tournament-container",
    ref: tournamentContainer
  }, renderPokerEventsList(tournaments)), moreItems && React.createElement(Button, {
    className: "btn-poker btn-show-all",
    disabled: isFetchingMore,
    onClick: () => {
      setOffset(offset + 5);
      setLiveMessage('Fler turneringar laddas in.');
    }
  }, "Visa fler"));
};
setGlobal('svs.poker_react.components.upcomingEvents.UpcomingEvents', UpcomingEvents);

 })(window);